/* global axios */
import ApiClient from './ApiClient';

class CrmReportsAPI extends ApiClient {
  constructor() {
    super('crm_reports', { accountScoped: true });
  }

  // Legacy endpoint

  getModules() {
    return axios.get(`${this.url}/modules`);
  }

  getPipelinesRanking(params = {}) {
    return axios.get(`${this.url}/pipelines_ranking`, { params });
  }

  getPipelineXray(params = {}) {
    return axios.get(`${this.url}/pipeline_xray`, { params });
  }

  getDealsExplorer(params = {}) {
    return axios.get(`${this.url}/deals_explorer`, { params });
  }

  getDealsLosses(params = {}) {
    return axios.get(`${this.url}/deals_losses`, { params });
  }

  getDealsWins(params = {}) {
    return axios.get(`${this.url}/deals_wins`, { params });
  }

  // Lista paginada de fechamentos ({ status: 'won'|'lost', page })
  getDealsClosedList(params = {}) {
    return axios.get(`${this.url}/deals_closed_list`, { params });
  }

  getAttributionOverview(params = {}) {
    return axios.get(`${this.url}/attribution_overview`, { params });
  }

  getCompaniesPortfolio(params = {}) {
    return axios.get(`${this.url}/companies_portfolio`, { params });
  }

  getTasksOverview(params = {}) {
    return axios.get(`${this.url}/tasks_overview`, { params });
  }

  getSalesRanking(params = {}) {
    return axios.get(`${this.url}/sales_ranking`, { params });
  }

  getSalesJourney(params = {}) {
    return axios.get(`${this.url}/sales_journey`, { params });
  }

  saveSalesJourney(stageIds) {
    return axios.post(`${this.url}/sales_journey`, { stage_ids: stageIds });
  }

  getDealsHeatmap(params) {
    return axios.get(`${this.url}/deals_heatmap`, { params });
  }

  getTickets(params = {}) {
    return axios.get(`${this.url}/tickets`, { params });
  }

  getPipelineVelocity(pipelineId) {
    return axios.get(`${this.url}/pipeline_velocity`, {
      params: { pipeline_id: pipelineId },
    });
  }

  getMarketingPerformance(params = {}) {
    return axios.get(`${this.url}/marketing_performance`, { params });
  }

  getDealsProducts(params = {}) {
    return axios.get(`${this.url}/deals_products`, { params });
  }

  getAgentDetail(params = {}) {
    return axios.get(`${this.url}/agent_detail`, { params });
  }

  getOverview(params = {}) {
    return axios.get(`${this.url}/overview`, { params });
  }

  getDealsForecast(params = {}) {
    return axios.get(`${this.url}/deals_forecast`, { params });
  }

  getAttributionPaths(params = {}) {
    return axios.get(`${this.url}/attribution_paths`, { params });
  }

  getGeoDeviceBreakdown(params = {}) {
    return axios.get(`${this.url}/geo_device_breakdown`, { params });
  }

  getBroadcastConversion(params = {}) {
    return axios.get(`${this.url}/broadcast_conversion`, { params });
  }

  getBroadcastConversionDetail(broadcastId) {
    return axios.get(`${this.url}/broadcast_conversion/${broadcastId}`);
  }

  getLandingPagesReport(params = {}) {
    return axios.get(`${this.url}/landing_pages_report`, { params });
  }

  getCampaignsReport(params = {}) {
    return axios.get(`${this.url}/campaigns_report`, { params });
  }
}

export default new CrmReportsAPI();
